import React, { useState } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { ArrowLeftIcon, ArrowRightIcon, Button, ChevronRightIcon, colors } from '@diversioteam/diversio-ds'

import { useGetPulseSurveysTemplates } from 'hooks/pulseSurveys/useGetPulseSurveysTemplates'
import { TemplateItem } from 'containers/PulseSurveys/TemplateItem'
import { generateCompanyURI } from 'sagas/helpers/generateCompanyURI'
import { AppRoute } from 'routing/AppRoute.enum'
import { ListSkeleton as TemplatesListSkeleton } from 'containers/PulseSurveys/Templates/List/skeleton'

import * as S from './templates.styles'

export const Templates = () => {
    const [page, setPage] = useState(1)

    const { data, isLoading } = useGetPulseSurveysTemplates({
        page,
        page_size: 4,
    })

    const handleClickPreviousPage = () => {
        setPage((prevState) => prevState - 1)
    }

    const handleClickNextPage = () => {
        setPage((prevState) => prevState + 1)
    }

    if (isLoading) {
        return <TemplatesListSkeleton data-testid="pulse-surveys-templates-skeleton" />
    }

    if (!data) {
        return null
    }

    const { page_size, total, items } = data

    if (items && items.length === 0) {
        return null
    }

    const hasPreviousPage = page > 1
    const hasNextPage = page_size * page < total

    return (
        <S.TemplatesWrapper>
            <S.Header>
                <S.Title as={RouterLink} to={generateCompanyURI(AppRoute.PulseSurveyTemplates)}>
                    Templates ({total})
                    <ChevronRightIcon type="bold" color={colors.primary50} width={16} height={16} />
                </S.Title>

                <S.Navigation>
                    <Button
                        onClick={handleClickPreviousPage}
                        disabled={!hasPreviousPage}
                        aria-label="Previous page"
                        size="small"
                        color="primaryWhite"
                        iconOnly
                    >
                        <ArrowLeftIcon type="bold" />
                    </Button>

                    <Button
                        onClick={handleClickNextPage}
                        disabled={!hasNextPage}
                        aria-label="Next page"
                        size="small"
                        color="primaryWhite"
                        iconOnly
                    >
                        <ArrowRightIcon type="bold" />
                    </Button>
                </S.Navigation>
            </S.Header>

            <S.List>
                {items.map((props) => (
                    <TemplateItem key={props.uuid} {...props} />
                ))}
            </S.List>
        </S.TemplatesWrapper>
    )
}
